export const mergeSessionUser = (nextUser, previousUser) => {
  if (!nextUser) {
    return nextUser;
  }

  return {
    ...previousUser,
    ...nextUser,
    client_id:
      nextUser.client_id ??
      nextUser.clientId ??
      nextUser.client?.id ??
      nextUser.client?.client_id ??
      previousUser?.client_id ??
      previousUser?.clientId ??
      previousUser?.client?.id ??
      previousUser?.client?.client_id ??
      null,
    client_name:
      nextUser.client_name ??
      nextUser.clientName ??
      nextUser.client?.client_name ??
      nextUser.client?.name ??
      previousUser?.client_name ??
      previousUser?.clientName ??
      previousUser?.client?.client_name ??
      previousUser?.client?.name ??
      "",
  };
};
